<template>
  <v-row
    :no-gutters="isMobileView"
    class="list-filter-buttons"
  >
    <!-- LIST SORT options-->
    <v-col
      :cols="isMobileView && isLargeMobile ? 3 : 4"
      :class="'py-0 overflow-hidden ' + (isMobileView ? ' px-0' : '')"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            float
            block
            tile
            class="elevation-0"
            :style="{
              color:
                searchFilters.sortBy !== 'sortOrder'
                  ? '#219bc8 !important'
                  : '',
            }"
            v-on="on"
          >
            <v-icon
              :small="isMobileView"
              :class="!isMobileView ? 'mr-2' : ''"
            >
              fa-sort-alpha-down
            </v-icon>
            {{ currentSortTitle }}
          </v-btn>
        </template>
        <v-list style="cursor: pointer">
          <v-list-item @click="changeSort('sortOrder')">
            <v-list-item-title>{{ $t('sorteeri') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeSort('dayPrice')">
            <v-list-item-title>{{ $t('sorteeri_hind') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeSort('region')">
            <v-list-item-title>{{ $t('sorteeri_asukoht') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <!-- FILTERS Open detailed search on mobile  -->
    <v-col
      v-if="isMobileView"
      :cols="isLargeMobile && isMobileView ? 3 : 4"
      class="py-0"
      :style="{
        borderRight: isMobileView ? '' : '1px solid #ddd',
        borderLeft: isMobileView ? '' : '1px solid #ddd',
      }"
    >
      <v-btn
        class="elevation-0"
        float
        block
        tile
        :style="{
          color: detailedSearch ? '#219bc8 !important' : '',
        }"
        @click="showFilters"
      >
        <v-icon
          :small="isMobileView"
          :class="!isMobileView ? 'mr-2' : ''"
        >
          fa-sliders-h
        </v-icon>
        {{ $i18n.t('filter') }}
      </v-btn>
    </v-col>

    <!-- FAVORITES on desktop -->
    <v-col
      v-if="isDesktopView"
      class="py-0"
    >
      <v-btn
        float
        block
        tile
        class="elevation-0"
        @click="goToFavorites"
      >
        <i
          :class="
            (searchFilters.favorites === 1 ? 'fa fa-heart' : 'far fa-heart') +
            (!isMobileView ? ' mr-2' : '')
          "
          :style="{
            color: '#e53935',
            position: 'relative',
            cursor: 'pointer',
            fontSize: '18px',
          }"
          v-tooltip.bottom-end="$t('saved_favorites')"
        />
        {{ $i18n.t('favourites') }}
      </v-btn>
    </v-col>

    <!-- REGION MENU/FILTER -->

    <v-col
      v-if="isLargeMobile || isDesktopView"
      :cols="isLargeMobile && isMobileView ? 3 : 4"
      class="py-0"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            float
            block
            tile
            class="elevation-0"
            :style="{
              color: searchFilters.region ? '#219bc8 !important' : '',
            }"
            v-on="on"
          >
            <v-icon
              :small="isMobileView"
              :class="!isMobileView ? 'mr-2' : ''"
            >
              fa-map-marked-alt
            </v-icon>
            {{ regionFilterTitle }}
          </v-btn>
        </template>
        <v-list style="cursor: pointer">
          <v-list-item @click="changeRegion({})">
            <v-icon small class="mr-2" color="grey darken-1">fa-map-marker-alt</v-icon>
            <v-list-item-title>{{
              capitalize($i18n.t('näita_kõik'))
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="(objectRegion, ori) in objectRegions.filter(
              (objectRegion) => !objectRegion.hidden
            )"
            :key="ori"
            @click="changeRegion(objectRegion)"
          >
            <v-icon small class="mr-2" color="grey darken-1">fa-map-marker-alt</v-icon>
            <v-list-item-title>{{ objectRegion.regionName }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <!-- MOBILE MAP icon -->
    <v-col
      v-if="isMobileView"
      :cols="isLargeMobile ? 3 : 4"
      class="py-0"
    >
      <v-btn
        float
        block
        tile
        class="elevation-0"
        @click="showMapOnMobile = !showMapOnMobile"
      >
        <v-icon
          :small="isMobileView"
          :class="!isMobileView ? 'mr-2' : ''"
        >
          fa-map
        </v-icon>
        {{ $i18n.t('map_view') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import sharedMethods from '@/methods/sharedMethods'
import sharedComputed from '@/methods/sharedComputed'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ListTopFilters',

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    regionFilterTitle() {
      if (parseInt(this.searchFilters.region)) {
        return this.objectRegions.filter(
          (region) => region.id === this.searchFilters.region
        )[0].regionName
      }
      return this.$i18n.t('region_short')
    },

    currentSortTitle() {
      const byKey = {
        sortOrder: this.$i18n.t('sorteeri'),
        dayPrice: this.$i18n.t('sorteeri_hind'),
        region: this.$i18n.t('sorteeri_asukoht'),
      }
      return byKey[this.searchFilters.sortBy]
    },
  },

  methods: {
    ...sharedMethods,

    showFilters() {
      if (this.detailedSearch) {
        this.detailedSearch = false
        this.scrollToBeginningOfListResult(true)
        return
      }
      this.detailedSearch = true
      this.scrollToBeginningOfFilters()
      // document.location.href = '#searchfilters'
    },

    changeRegion(region) {
      Vue.set(this.searchFilters, 'region', region.id)
      this.searchFormSubmit()
    },

    changeSort(condition) {
      Vue.set(this.searchFilters, 'sortBy', condition)
    },
  },
}
</script>
